import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"opacity":"0","pointer-events":"none","position":"absolute"} }
const _hoisted_2 = { key: 0 }

import {Settings} from "~/node_modules/@types/tinymce";
import ContentVariables from "~/cabinet/vue/client/sender/send/ContentVariables.vue";
import {Editor as EditorClass} from "tinymce";
import TextInputWithVariablesHelper from "~/cabinet/vue/interface/tinymce/TextInputWithVariablesHelper";
import {useInputWithVariables, useInputWithVariablesProps} from "~/cabinet/vue/interface/tinymce/useInputWithVariables";
import {computed, inject, onActivated, onDeactivated, PropType, ref, watch} from "vue";
import {
    ContentVariablesComponentExposeInterface
} from "~/cabinet/vue/client/sender/send/ContentVariablesComponentExposeInterface";
import {FileManagerRootInjectionKey} from "~/cabinet/vue/interface/form/FileManagerRootInjection";
import AbstractUploadHelper from "~/ts/library/AbstractUploadHelper";
import CsrfToken from "~/core-ui/ts/request/CsrfToken";
import {LoadingService} from "~/core-ui/ts/InitElemeUI";


import TinyMceEditor from '@tinymce/tinymce-vue';


const __default__ = {
    name: "HtmlInputWithVariables",
    components: {
        TinyMceEditor: TinyMceEditor
    }
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useInputWithVariablesProps(),
    inline: {
        type: Boolean,
        default: true
    },
    height: {type: Number},
    oldChatCss: {type: Boolean},
    likeTextarea: {type: Boolean},
    verifyHtml: {type: Boolean, default: true},
    allowStyleTag: {type: Boolean, default: false},
    editorClassList: {type: Array, default: () => [] as any[]},
    toolbar: {type: Array as PropType<string[]>},
    showPageBreakButton: {type: Boolean},
    uploadHandler: {type: Object as PropType<AbstractUploadHelper>},
    rootElement: {type: String}
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

let props = __props;

let emits = __emit;

let contentVariables = ref<ContentVariablesComponentExposeInterface>();
let editor = ref<any>();
let variableExample = ref<HTMLSpanElement>();
let active = ref(true);

let filemanagerRootInjection = inject(FileManagerRootInjectionKey, null);

let {dataLabelAttribute, commonSettings, variableGroups, paste, getSettings, helper} = useInputWithVariables(props, {
    setup: (editor: EditorClass) => {
        if (!props.inline) {
            let variableStyle = window.getComputedStyle(variableExample.value).cssText;

            editor.settings.content_style = `
                    .noneditable-variable { ${variableStyle}; width: auto; height: auto; line-height: 2; font-size:0; }
                    .noneditable-variable:before {
                        content: attr(${dataLabelAttribute.value});
                        font-size: 12px;
                        font-weight: bold;
                        background: #f0f2f5 !important;
                        color: #6e7c94 !important;
                        border-radius: 5px;
                        border-top: 1px solid #e6e8ed;
                        padding: 0 1px;
                        display: inline-block;
                        line-height: 1.5;
                    }
                `;
        }

        if (props.uploadHandler) {
            editor.on('paste', function (e: ClipboardEvent) {

                function retrieveImageFromClipboardAsBlob(pasteEvent: ClipboardEvent) {
                    if (!pasteEvent.clipboardData) {
                        return false;
                    }

                    var items = pasteEvent.clipboardData.items;

                    if (items === undefined) {
                        return false;
                    }

                    for (var i = 0; i < items.length; i++) {
                        // Only paste if image is only choice
                        if (items[i].type.indexOf("image") === -1) {
                            return false;
                        }
                        // Retrieve image on clipboard as blob
                        var blob = items[i].getAsFile();

                        // load image if there is a pasted image
                        if (blob !== null) {
                            const reader = new FileReader();
                            reader.readAsDataURL(blob);
                            return blob;
                        }
                    }
                    return false;
                }

                function uploadFile(file: File, callback: (resp: any) => void) {
                    let loader = LoadingService({
                        fullscreen: true,
                        lock: true
                    });
                    try {
                        var xhr = new XMLHttpRequest();


                        xhr.onload = function () {
                            if (xhr.status !== 200) {
                                alert("Не удалось загрузить файл: " + xhr.response);
                            }
                            if (callback) {
                                loader.close();
                                callback(JSON.parse(xhr.response));
                            }
                        };

                        xhr.onerror = function () {
                            loader.close();
                            alert("Не удалось загрузить файл");
                        };

                        xhr.open("POST", props.uploadHandler.getUrl(), true);
                        xhr.setRequestHeader('X-Csrf-Token', CsrfToken.get());
                        var data = new FormData();
                        data.append('file', file);
                        xhr.send(data);
                    } catch (e) {
                        console.error(e);
                        loader.close();
                    }
                }

                var imageBlob = retrieveImageFromClipboardAsBlob(e);
                if (!imageBlob) {
                    return;
                }
                e.preventDefault();


                uploadFile(imageBlob, function (response: any) {
                    try {
                        let url = response?.data?.url;
                        if (editor) {
                            let img = document.createElement("img");
                            img.src = url;
                            editor.insertContent(img.outerHTML);
                        } else {
                            console.log('Tinymce editor not found!');
                        }
                    } catch (e) {

                    }
                });
            });
        }
    },
    getContentVariablesComponent: () => contentVariables.value,
    getEditor: () => editor.value?.getEditor(),
    getPlugins: () => ([
        'lists',
        //'responsivefilemanager',
        'image',
        'table',
        'link',
        'code',
        'pagebreak'
    ]),
    getSettings: () => {

        let result: Settings = {
            ...commonSettings.value,
            browser_spellcheck: true,
            verify_html: props.verifyHtml,
            custom_elements: props.allowStyleTag ? "style" : "",
            extended_valid_elements: (props.allowStyleTag ? ",style[type],style" : ""),
            inline: props.inline,
            skin: "oxide-dark",
            external_plugins: {
                filemanager: "/cabinet/assets/scripts/tinymce/plugins/filemanager.plugin.js"
            },
            external_filemanager_path: `/filemanager/`,
            filemanager_root: filemanagerRootInjection?.value,
            filemanager_title: "Файловый менеджер",
            resize: true,
            statusbar: true,
            link_list: props.contentVariables.map(item => ({
                title: item.descr,
                value: TextInputWithVariablesHelper.getAnchorByVariable(item.id)
            }))
        } as Settings;
        if (props.rootElement) {
            result.forced_root_block = props.rootElement;
        }
        if (props.oldChatCss) {
            if (!result.content_css) {
                result.content_css = [];
            }
            (result.content_css as string[]).push('/cabinet/assets/css/cabinet/online/old-chat-css.css');

        }
        return result;
    },
    getToolbar: () => {
        if (props.toolbar) {
            return props.toolbar;
        }
        let pageBreak = props.showPageBreakButton ? ' | pagebreak' : '';
        return [
            "undo redo | bold italic underline strikethrough fontsizeselect | h1 h2 h3 h4 | backcolor forecolor | removeformat ",
            `alignleft aligncenter alignright alignjustify | link unlink image | bullist numlist | table | code${pageBreak} | PasteContentVariable`
        ];
    },
    isHtml: () => true,
    isBbCode: () => false
});

let settings = computed(() => getSettings());

watch(settings, () => {
    if (active.value) {
        active.value = false;
        setTimeout(() => active.value = true, 10);
    }
});


onDeactivated(() => {
    active.value = false;
});

onActivated(() => {
    active.value = true;
});

let isHtml = computed(() => {
    return true;
});

let style = computed(() => {
    let result: any = {};
    if (props.height) {
        result.height = `${props.height}px`;
    }
    return result;
});

let variableClassName = computed(() => {
    return TextInputWithVariablesHelper.className;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
        zIndex0: true,
        'el-textarea': __props.likeTextarea
    })
  }, [
    _createVNode(ContentVariables, {
      hidden: "",
      ref_key: "contentVariables",
      ref: contentVariables,
      "variable-groups": _unref(variableGroups),
      onPaste: _unref(paste)
    }, null, 8, ["variable-groups", "onPaste"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        ref_key: "variableExample",
        ref: variableExample,
        class: _normalizeClass(_unref(variableClassName))
      }, null, 2)
    ]),
    (_unref(active))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createBlock(_unref(TinyMceEditor), {
            "model-value": _ctx.modelValue,
            style: _normalizeStyle(_unref(style)),
            init: _unref(settings),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('update:modelValue', $event))),
            key: _unref(helper).getId(),
            disabled: _ctx.disabled,
            ref_key: "editor",
            ref: editor,
            class: _normalizeClass(['tinymce-for-input-with-variables', __props.inline ? 'inline' : null, __props.likeTextarea ? 'el-textarea__inner' : false, ...__props.editorClassList]),
            spellcheck: "true"
          }, null, 8, ["model-value", "style", "init", "disabled", "class"]))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})